import { SmIcon } from '@smiles/smiles-react-design-system';
import React, { useMemo } from 'react';
import { ListItemUtils } from '../../utils';

import { useContextSelector } from '../../../../hooks';
import type { GetSearchLocation } from '../../../../types';

export interface IListItemProps {
  item: GetSearchLocation;
  onSelect: (item: GetSearchLocation) => void;
}

export const ListItem = ({ item, onSelect, ...props }: IListItemProps) => {
  const {
    generics: { isMobile },
  } = useContextSelector();

  const locationData = useMemo(() => {
    const name = item.name;
    const type = ListItemUtils.getLocationType(item);
    const description = ListItemUtils.getLocationAmountOfStores(item);

    return { name, description, type };
  }, [item]);

  const preventInputBlur = (event: React.MouseEvent<HTMLButtonElement>) => {
    /*
      If you want to prevent the blur event of an input from being fired,
      you have to do so when you are inside the 'mousedown' event of the
      element that should not trigger the blur. You can do so by invoking
      the method preventDefault() on the event.
    */
    event.preventDefault();
  };

  const handleItemClick = () => {
    onSelect(item);
  };

  return isMobile ? (
    <li className="search-input-dropdown-list-item" {...props}>
      <section className="search-input-dropdown-list-item-wrapper">
        <button
          type="button"
          className="search-input-dropdown-list-item-button"
          onMouseDown={preventInputBlur}
          onMouseUp={handleItemClick}
        >
          <SmIcon className="search-input-dropdown-list-item-type-icon" name={locationData.type} type="round" />

          <article className="search-input-dropdown-list-item-text-wrapper">
            <span className="search-input-dropdown-list-item-text-title">{locationData.name}</span>

            {locationData.description && (
              <span className="search-input-dropdown-list-item-text-description">{locationData.description}</span>
            )}
          </article>
        </button>
      </section>
    </li>
  ) : (
    <li className="search-input-dropdown-list-item" {...props}>
      <button
        type="button"
        className="search-input-dropdown-list-item-button"
        onMouseDown={preventInputBlur}
        onMouseUp={handleItemClick}
      >
        <SmIcon className="search-input-dropdown-list-item-type-icon" name={locationData.type} type="round" />

        <article className="search-input-dropdown-list-item-text-wrapper">
          <span className="search-input-dropdown-list-item-text-title">{locationData.name}</span>

          {locationData.description && (
            <span className="search-input-dropdown-list-item-text-description">{locationData.description}</span>
          )}
        </article>
      </button>
    </li>
  );
};
